import { render, staticRenderFns } from "./workorderpacklist.vue?vue&type=template&id=3f9af9d4&scoped=true"
import script from "./workorderpacklist.vue?vue&type=script&lang=js"
export * from "./workorderpacklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9af9d4",
  null
  
)

export default component.exports